import React, { PropTypes, Component } from 'react';
import idx from 'idx';
import IntercomChat from 'common/containers/intercom_chat';
import { STAGE_VOTE, STAGE_DONE } from 'focus_groups/ducks/vote';
import { getClientLabel, sortRevisionsByScore } from 'focus_groups/utils';
import { LoadingIndicator } from 'common/components/preloader';
import Avatar from 'common/components/avatar';
import Gallery from 'common/components/gallery';
import VotingModal from 'focus_groups/containers/voting_modal';
import VotingTile from 'focus_groups/containers/voting_tile';
import VotingFormTile from 'focus_groups/containers/voting_form_tile';
import ParticipantInfoForm from 'focus_groups/containers/participant_info_form';
import VoteHero from 'focus_groups/components/vote_hero';

export default class Vote extends Component {
  constructor(props) {
    super(props);
    this.onSelect = this.onSelect.bind(this);
  }

  componentDidMount() {
    const { isAnonymous, fetch, identify, setStage } = this.props;

    fetch();

    setStage(STAGE_VOTE);

    /* if user is anonymous, identify her as a participant */
    if (isAnonymous) {
      identify();
    }
  }

  onSelect(revisionId) {
    const { setVoteIndex, viewState, stage, fetch, toggleVoting } = this.props;

    /* ignore if on done stage */
    if (stage === STAGE_DONE) {
      return;
    }

    const group = idx(viewState, _ => _.currentGroup);
    const index = group.revisions.findIndex(({ id }) => (id === revisionId));

    /* fetch updated group before showing vote modal */
    fetch().then(() => {
      toggleVoting();
      setVoteIndex(index);
    });
  }

  renderVoteStage() {
    const { viewState } = this.props;
    const group = idx(viewState, _ => _.currentGroup);
    const client = idx(group, _ => _.project.client) || {};

    return (
      <div className="vote-stage">
        <section className="participate-intro">
          <div className="row">
            <div className="columns small-16 large-2">
              <Avatar user={client} extraClasses="avatar-lg avatar-round" />
            </div>
            <div className="columns large-10">
              <p className="focus-group-description">{ group.purpose }</p>
            </div>
          </div>
        </section>
        <section className="project-entries-gallery">
          <div className="row columns">
            <Gallery
              classes="row small-up-1 medium-up-2 large-up-4"
              list={group.revisions}
              tile={VotingFormTile}
              onTileSelect={this.onSelect}
              keyField="id"
            />
          </div>
        </section>
        <section>
          <div className="row">
            <div className="columns small-16 medium-9">
              <ParticipantInfoForm submittingVotes={true} />
            </div>
          </div>
        </section>
        <VoteHero />
        <VotingModal />
      </div>
    );
  }

  renderDoneStage() {
    const { viewState } = this.props;
    const group = idx(viewState, _ => _.currentGroup);

    return (
      <div className="done-stage">
        { group.share_results?
        <div>
          <div className="row columns">
            <h2>Check out the results.</h2>
          </div>
          <section className="project-entries-gallery">
            <div className="row columns">
              <Gallery
                classes="row small-up-1 medium-up-2 large-up-4"
                list={sortRevisionsByScore(group.revisions)}
                tile={VotingTile}
                onTileSelect={this.onSelect}
              />
            </div>
          </section>
        </div> :
        <div className="row columns">
          <h2>Thanks for your feedback.</h2>
        </div> }
        <VoteHero />
      </div>
    );
  }

  renderClosed() {
    const { viewState } = this.props;
    const group = idx(viewState, _ => _.currentGroup);
    const client = idx(group, _ => _.project.client) || {};
    const clientLabel = getClientLabel(client);

    return (
      <div className="closed">
        <section className="notice">
          <div className="row columns">
            <h2>Bummer!</h2>
            <p>{ clientLabel } has closed this focus group.</p>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="columns small-16 medium-6">
              <h3>Want to know which design is picked as the winner?</h3>
            </div>
            <div className="columns small-16 medium-offset-2 medium-8">
              <ParticipantInfoForm />
            </div>
          </div>
        </section>
        <VoteHero />
      </div>
    );
  }

  render() {
    const { viewState, stage } = this.props;
    const group = idx(viewState, _ => _.currentGroup);

    if (viewState.isFetching || !group) {
      return (<LoadingIndicator />);
    }

    let content = null;

    if (group.status === 'closed') {
      content = this.renderClosed();
    } else if (stage === STAGE_VOTE) {
      content = this.renderVoteStage();
    } else if (stage === STAGE_DONE) {
      content = this.renderDoneStage();
    }

    return (
      <div className="l-content focus-group-participate" id="content">
        { content }
        <IntercomChat />
      </div>
    );
  }
}

Vote.propTypes = {
  fetch: PropTypes.func.isRequired,
  viewState: PropTypes.shape({
    isFetching: PropTypes.bool,
    currentGroup: PropTypes.object,
  }),
  isVoting: PropTypes.bool,
  isAnonymous: PropTypes.bool,
  stage: PropTypes.string,
  toggleVoting: PropTypes.func.isRequired,
  setVoteIndex: PropTypes.func.isRequired,
  setStage: PropTypes.func.isRequired,
  identify: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./focus_groups/components/vote.jsx